export default __webpack_public_path__ + "static/media/snake.7a858ebd.jpg";